import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent implements OnInit {
  @Input() active: boolean = false;
  @Input() position?: Object = {
    absolute: false,
  };

  constructor() {}

  ngOnInit(): void {}
}
